import { FC, useState } from 'react';

import classNames from 'classnames';

import { MacCardList } from '../../mac-card-list';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { setMacSelected } from '../../../store/mac.slice';

import { TabList } from '../../../shared/ui';

import { MacCardsSelected } from './mac-card-selected';
import { MacResultsMobile } from './mac-results-mobile';

export interface IMacCardsClientProps {
  /** Идентификатор участника — выбор карт привязывается к нему (разделение при нескольких клиентах) */
  participantIdentity?: string;
  /** Групповая терапия: отправить выбор по data channel (вместо socket) */
  sendMacSelectCards?: (result: Array<{ id: number; img: string; selected: boolean }>) => void;
  /** Групповая терапия: 6 столбцов в сетке карт */
  isGroupTherapy?: boolean;
  /** Мобильный 1:1: компактный выбор карт (заголовок и видео-превью лежат в верхней полосе сцены) */
  mobile?: boolean;
}

type ViewMode = 'own' | 'shared';

export const MacCardsClient: FC<IMacCardsClientProps> = ({
  participantIdentity,
  sendMacSelectCards,
  isGroupTherapy,
  mobile = false,
}) => {
  const dec = useAppSelector((state) => state.macStateSlice.currentDec);
  const selectedCards = useAppSelector((state) => state.macStateSlice.selected);
  const sharedView = useAppSelector((state) => state.macStateSlice.sharedView);
  const dispatch = useAppDispatch();

  const [viewMode, setViewMode] = useState<ViewMode>('own');

  if (!isGroupTherapy) {
    return (
      <div
        id="ClentMC"
        className={classNames('h-full w-full flex flex-row', mobile ? '' : 'pr-[0.25rem]', {
          'lg:min-w-[600px] md:min-w-[400px]': selectedCards.length <= 0,
        })}
      >
        {selectedCards.length > 0 ? (
          mobile ? (
            <MacResultsMobile cards={selectedCards} title="Ваш выбор" />
          ) : (
            <MacCardsSelected selectedCards={selectedCards} />
          )
        ) : (
          <MacCardList
            mobile={mobile}
            cards={dec}
            selectedCards={selectedCards}
            setSelectedCards={(s) => {
              dispatch(setMacSelected(s));
            }}
            onSubmitViaDataChannel={sendMacSelectCards}
          />
        )}
      </div>
    );
  }

  const hasShared = Boolean(sharedView && sharedView.cards.length > 0);
  const showToggle = selectedCards.length > 0 && hasShared;
  const activeCards = viewMode === 'shared' && sharedView ? sharedView.cards : selectedCards;
  const sharedLabel = sharedView?.participantLabel
    ? `Карты участника ${sharedView.participantLabel}`
    : 'Карты на общем экране';

  return (
    <div
      id="ClentMC"
      className="h-full w-full min-h-0 flex flex-col bg-white rounded-chip md:rounded-card overflow-hidden"
    >
      {selectedCards.length > 0 ? (
        <>
          {showToggle && (
            <div className="flex shrink-0 px-4 pt-3 pb-1 gap-2">
              <TabList<ViewMode>
                variant="segmented"
                value={viewMode}
                onChange={setViewMode}
                items={[
                  { id: 'own', label: 'Мои карты' },
                  { id: 'shared', label: sharedLabel },
                ]}
              />
            </div>
          )}
          <div className="flex-1 min-h-0 p-4 overflow-hidden flex flex-col">
            <MacCardsSelected
              selectedCards={activeCards}
              isGroupTherapy={isGroupTherapy}
              fillContainerHeight={isGroupTherapy}
            />
          </div>
        </>
      ) : (
        <MacCardList
          cards={dec}
          selectedCards={selectedCards}
          setSelectedCards={(s) => {
            dispatch(setMacSelected(s));
          }}
          participantIdentity={participantIdentity}
          onSubmitViaDataChannel={sendMacSelectCards}
          isGroupTherapy={isGroupTherapy}
        />
      )}
    </div>
  );
};
